import { render, staticRenderFns } from "./order-comments.vue?vue&type=template&id=4419efac&scoped=true"
import script from "./order-comments.vue?vue&type=script&lang=ts"
export * from "./order-comments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4419efac",
  null
  
)

export default component.exports